export default __webpack_public_path__ + "static/media/blogImg3.53425b64.png";